import queryString from 'query-string'

export function reverse(routeId, params) {
  return { type: routeId, ...params }
}

export const locationSelector = state => {
  const location = state.get('location')

  // `location.query` is supposed to always exist since we specify
  // `querySerializer: queryString` in states/routes.js but something’s buggy
  // so parse it here if needed as a workaround.
  return location.query != null
    ? location
    : {
        ...location,
        query: queryString.parse(location.search),
      }
}

export const filterLinks = (links, account) => {
  const role = account && account.get('signupFlow')

  return links
    .filter(({ auth, exceptRole }) => {
      // Links can optionally define `auth` as a boolean to only show
      // for either non-logged in or logged in users.
      if (typeof auth === 'boolean') {
        // Hide items that depend on the logged in state until we know
        // whether we’re logged in or not.
        if (account === false) {
          return false
        }

        const isAuthed = account != null
        return auth === isAuthed
      }
      // filter items in which exceptRole matches current users role
      if (typeof exceptRole === 'string') {
        return exceptRole !== role
      }
      return true
    })
    .map(({ auth, exceptRole, ...rest }) => ({ ...rest }))
}



// WEBPACK FOOTER //
// ../source/utilities/routes.js